import { environment } from 'environments/environment'
export class IntimationDO {

	public companyName: any;
	public causeOfDeathCd: any;
	public clmIntimationNum: any;
	public countryOfDeathCd: any;
	public effectiveDt: any;
	public entryDt: any;
	public errorFl: any;
	public eventDt: any;
	public eventTm: any;
	public eventTypeCd: any;
	public intimationDt: any;
	public mannerOfLossCd: any;
	public mannerOfLossDesc: any;
	public pendingReqFl: any;
	public placeOfDeathCd: any;
	public placeOfDeathDesc: any;
	public receivedDt: any;
	public stageCd: any;
	public statusCd: any;
	public submissionModeCd: any;
	public policies: Array<any>;
	// public intimationClientRoles: Array<IntimationClientRole>; 
	public claimClientRoles: Array<ClaimClientRole>;//claimClientRoles
	// public intimationHospitalisations: Array<IntimationHospitalisation>; 
	public claimHospitalization: Array<ClaimHospitalisation>; // claimHospitalization
	// public intimationMedicalConditions: Array<IntimationMedicalCondition>;
	public claimMedicalConditions: Array<ClaimMedicalCondition>; //claimMedicalConditions
	// public intimationPayments: Array<IntimationPayment>;
	public claimPayments: Array<ClaimPayment>; //claimPayments
	public id: any;

	constructor() {
		this.initialize()
	}


	initialize() {
		this.companyName = null
		this.causeOfDeathCd = null
		this.clmIntimationNum = null
		this.countryOfDeathCd = null
		this.effectiveDt = null
		this.entryDt = null
		this.errorFl = null
		if (environment.production)
			this.eventDt = [
				2019,
				5,
				20
			]
		this.eventTm = null
		this.eventTypeCd = null
		this.intimationDt = null
		this.mannerOfLossCd = null
		this.mannerOfLossDesc = null
		this.pendingReqFl = null
		this.placeOfDeathCd = null
		this.placeOfDeathDesc = null
		this.receivedDt = null
		this.stageCd = null
		this.statusCd = null
		this.submissionModeCd = null
		this.policies = [];
		// this.intimationClientRoles = [];
		// this.intimationHospitalisations = [];
		// this.intimationMedicalConditions = [];
		// this.intimationPayments = [];
		this.claimClientRoles = [];
		this.claimHospitalization = [];
		this.claimMedicalConditions = [];
		this.claimPayments = [];
		this.id = null
	}



}

export class ClaimClientRole {

	public id: any;
	constructor(
		public clientRefGuid: any,
		public roleCd: any, 
		public deDupStatusCd?: any,
		id?: any,
		public nomineeForInsured?: any,
		public splitPercentage?: any) {
		if (id) this.id = id
		else id = null


	}

}

export class ClaimHospitalisation {

	public id: any;

	constructor(public admissionDt: any,
		public conditionCdCSV: any,
		public dischargeDt: any,
		public doctorNum: any,
		public hospitalCd: any,
		id?: any) {
		if (id) this.id = id
		else id = null
	}

}

export class ClaimMedicalCondition {

	public id: any;
	constructor(public conditionCd: any,
		public firstDiagnosisDt: any,
		public medication: any,
		public objectName: any,
		public statusCd: any,
		public treatingDoctorNum: any,
		id?: any) {
		if (id) this.id = id
		else id = null
	}
}

export class ClaimPayment {
	public id: any;
	constructor(public accountHolderName: any,
		public accountNumber: any,
		public bankName: any,
		public branchIdNum1: any,
		public branchIdNum2: any,
		public branchName: any,
		public paymentFrequencyCd: any,
		public paymentMethodCd: any,
		id?: any) {
		if (id) this.id = id
		else id = null
	}
}


